import { useLocation } from 'react-router-dom';
import { TopBar } from 'shared-ui';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { AppRoute } from 'routing/AppRoute.enum';
import { useSelectedSearchOptions } from 'hooks/useSelectedSearchOptions/useSelectedSearchOptions';
import { AddWantedContainer } from '../addWanted/AddWantedContainer';
import { TableSearchContainer } from 'reusable/tableSearch/TableSearchContainer';
import { usePermissions } from 'hooks/usePermissions/usePermissions';
import { Functionality } from 'api/userPermissions/userPermissions.enum';

import { WantedBarProps } from './WantedBar.types';

export const WantedBar = ({ searchQueryKey, setTableSearchQuery }: WantedBarProps) => {
  const { formatMessage } = useLocale();
  const location = useLocation();

  const { searchOption, setSelectedSearchOption } = useSelectedSearchOptions(searchQueryKey, setTableSearchQuery);
  const { perms } = usePermissions();
  const canViewWantedHistory = perms?.[Functionality.HISTORIA]?.view;

  return (
    <TopBar gridTemplateColumns="auto auto 1fr auto">
      <TopBar.Link linkTo={AppRoute.wanted} isActive={location.pathname === AppRoute.wanted}>
        {formatMessage({ id: AppMessages['wanted.title'] })}
      </TopBar.Link>

      <TopBar.Link
        linkTo={AppRoute.wantedHistory}
        isActive={location.pathname === AppRoute.wantedHistory}
        disabled={!canViewWantedHistory}
        tooltipText={!canViewWantedHistory ? formatMessage({ id: AppMessages['common.noPermissions'] }) : undefined}
      >
        {formatMessage({ id: AppMessages['wanted.history'] })}
      </TopBar.Link>

      {setTableSearchQuery ? (
        <TopBar.Search>
          <TableSearchContainer
            searchIconTestId="page-search"
            inputPlaceholder={formatMessage({ id: AppMessages['wanted.search'] })}
            searchBy="owners"
            setTableSearchQuery={setTableSearchQuery}
            selectedValue={searchOption}
            setSelectedValue={setSelectedSearchOption}
            archived={false}
          />
        </TopBar.Search>
      ) : (
        <TopBar.EmptyBarWithLine />
      )}

      <TopBar.ButtonsWrapper>
        <AddWantedContainer />
      </TopBar.ButtonsWrapper>
    </TopBar>
  );
};
